import * as CubeTree from '../../../cubeTree/index';
import * as UIToolkit from '../../../UIToolkit/layer/index';
import * as Toolkit from '../../../toolkit/index';
import CodiSystem from '../../../codiSystem/index';
import { findNextLayerCube } from '../funcs/findNextLayerCube';

function makeMoveTask(arrow: TextareaInsertArrow, dragCubes: CubeId[], transfer: Transfer): MoveTask {
    let result: MoveTask = {
        logic: [],
        physics: []
    };

    result.logic = makeLogicTask(arrow, dragCubes);
    result.physics = makePhysicsTask(arrow, dragCubes, transfer);

    return result;
}

function makeLogicTask(arrow: TextareaInsertArrow, dragCubes: CubeId[]): LogicMoveTask[] {
    // 目标点是层板
    if (CubeTree.isPartition(arrow.target)) {
        return makeMoveToLayerTask(arrow.target, dragCubes);
    }

    // 目标点是层板中的组件
    if (CubeTree.isInLayer(arrow.target)) {
        return moveToLayerCube(arrow, dragCubes);
    }

    // 目标点是画布
    if (CubeTree.isSketchpad(arrow.target)) {
        return makeMoveToStageTask(arrow, dragCubes);
    }

    return [];
}

// todo: from坐标有问题，做历史记录时需要优化
function makePhysicsTask(arrow: TextareaInsertArrow, dragCubes: CubeId[], transfer: Transfer): PhysicsMoveTask[] {
    let result: PhysicsMoveTask[] = [];
    let dragCubeCoordinates: CubePaintCoordinate[] = transfer.getDragCubePaintCoordinate();

    dragCubeCoordinates.forEach((coordinate: CubePaintCoordinate): void => {
        let from: PhysicsCoordinate = CodiSystem.getRelativePhysicsCoordinate(coordinate.id);
        let to: PhysicsCoordinate;

        if (CubeTree.isPartition(arrow.target) && UIToolkit.layoutType(arrow.target) === '|-|--|---') {
            let base: PhysicsCoordinate = CodiSystem.getPhysicsCoordinate(arrow.target);
            let target: PhysicsCoordinate = CodiSystem.paintToPhysics({
                left: coordinate.left,
                top: coordinate.top,
                width: coordinate.width,
                height: coordinate.height
            });
            let relative: PhysicsCoordinate = CodiSystem.getPhysicsRelative(target, base);

            to = relative;
            to.bottom = 0;
        }
        else {
            to = CodiSystem.paintToPhysics({
                left: coordinate.left,
                top: coordinate.top,
                width: coordinate.width,
                height: coordinate.height
            });
        }

        result.push({
            from: {
                moveTarget: coordinate.id,
                position: {
                    left: from.left,
                    bottom: from.bottom
                }
            },
            to: {
                moveTarget: coordinate.id,
                position: {
                    left: to.left,
                    bottom: to.bottom
                }
            }
        });
    });

    return result;
}

function isNeedMovePhysics(arrow: TextareaInsertArrow): boolean {
    return CubeTree.isSketchpad(arrow.target)
        || (CubeTree.isPartition(arrow.target)
        && UIToolkit.layoutType(arrow.target) === '|-|--|---');
}

// 移动至舞台，需要判断逻辑关系是否发生变化，如果没发生变化，则不需要做逻辑移动
function makeMoveToStageTask(arrow: TextareaInsertArrow, dragCubes: CubeId[]): LogicMoveTask[] {
    let result: LogicMoveTask[] = [];

    dragCubes.forEach((cubeId: CubeId): void => {
        let oldParent: CubeId|null = CubeTree.findParentIdByCubeId(cubeId);
        let oldBefore: CubeId|null = findNextLayerCube(cubeId, dragCubes);

        result.push({
            from: {
                parent: oldParent,
                moveTarget: cubeId,
                before: oldBefore
            },
            to: {
                parent: arrow.target,
                moveTarget: cubeId,
                insertBefore: null
            }
        });
    });

    return result;
}

function moveToLayerCube(arrow: TextareaInsertArrow, dragCubes: CubeId[]): LogicMoveTask[] {
    if (arrow.direction === 'middle') {
        return [];
    }

    return normalInsert(arrow, dragCubes);
}

function normalInsert(arrow: TextareaInsertArrow, dragCubes: CubeId[]): LogicMoveTask[] {
    let result: LogicMoveTask[] = [];

    dragCubes.forEach((cubeId: CubeId): void => {
        if (cubeId === arrow.target) {
            return;
        }

        let oldParent: CubeId|null = CubeTree.findParentIdByCubeId(cubeId);
        let oldBefore: CubeId|null = findNextLayerCube(cubeId, dragCubes);
        let targetLayer: CubeId = CubeTree.findCubeLayer(arrow.target);
        let insertTarget: CubeId|null = arrow.target;

        if (arrow.direction === 'right') {
            insertTarget = CubeTree.findNextCube(arrow.target, dragCubes);
        }

        if (UIToolkit.layoutType(targetLayer) === '|-|--|---') {
            result.push({
                from: {
                    parent: oldParent,
                    moveTarget: cubeId,
                    before: oldBefore
                },
                to: {
                    parent: targetLayer,
                    moveTarget: cubeId,
                    insertBefore: null
                }
            });
            return;
        }

        result.push({
            from: {
                parent: oldParent,
                moveTarget: cubeId,
                before: oldBefore
            },
            to: {
                parent: targetLayer,
                moveTarget: cubeId,
                insertBefore: insertTarget
            }
        });
    });

    return result;
}

function makeMoveToLayerTask(layer: CubeId, dragCubes: CubeId[]): LogicMoveTask[] {
    let result: LogicMoveTask[] = [];

    dragCubes.forEach((cubeId: CubeId): void => {
        let itsParent: CubeId = CubeTree.findParentIdByCubeId(cubeId);
        let oldBefore: CubeId|null = findNextLayerCube(cubeId, dragCubes);

        result.push({
            from: {
                parent: itsParent,
                moveTarget: cubeId,
                before: oldBefore
            },
            to: {
                parent: layer,
                moveTarget: cubeId,
                insertBefore: null
            }
        });
    });

    return result;
}

export {
    makeMoveTask
};
